import { IsNotEmpty, IsNumber, IsString } from 'class-validator';

export class OmieProjectDto {
  @IsNumber()
  @IsNotEmpty()
  id: number;

  @IsString()
  @IsNotEmpty()
  name: string;
}
